export const ADD_EVENT = "ADD_EVENT";
export const REMOVE_EVENT = "REMOVE_EVENT";
export const RESET_TIME_SERIES = "RESET_TIME_SERIES";
export const UPDATE_TIME_SERIES = "UPDATE_TIME_SERIES";
